export const SLITE_UTM_CONTEXT_KEY = 'slite_utm_context'
export const REFERRER_KEY = 'referrer'

// Temporary keys we might be setting up during onboarding, that need to be cleared after the session is over
export const QUALIFIED_TEAM_KEY = 'qualified-team'
export const PREVIOUS_STEP_KEY = 'slite-boarding-previous-step'
export const FROM_MOBILE_APP_KEY = 'fromMobileApp'
export const ASK_STANDALONE_ENABLED_KEY = 'askStandaloneEnabled' // @deprecated to be removed soom
export const SUPER_ENABLED_KEY = 'superEnabled'
export const SUPER_TRIAL_TOKEN_KEY = 'superTrialToken'

export const setItemSafe = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value)
  } catch {}
}

export const getItemSafe = (key: string) => {
  try {
    return localStorage.getItem(key)
  } catch {
    return undefined
  }
}

export const clearSessionSafe = () => {
  try {
    localStorage.removeItem(QUALIFIED_TEAM_KEY)
    localStorage.removeItem(PREVIOUS_STEP_KEY)
    localStorage.removeItem(FROM_MOBILE_APP_KEY)
    localStorage.removeItem(ASK_STANDALONE_ENABLED_KEY)
    localStorage.removeItem(SUPER_ENABLED_KEY)
    localStorage.removeItem(SUPER_TRIAL_TOKEN_KEY)
  } catch {}
}
